import {useFormContext} from 'react-hook-form';

export interface ICustomFormError {
    errorKey: string;
    children: JSX.Element;
}

const CustomFormError = (props: ICustomFormError) => {
    const {errorKey, children} = props;
    const {errors} = useFormContext();

    return <>{errors[errorKey] ? children : null}</>;
};

export default CustomFormError;
